import React, { useContext } from "react"
import { useFormContext } from "react-hook-form"
import { GeneralSettingsContext } from "src/main/Settings/General"

import Form from "src/components/Form"
import HeadingPageTitle from "src/components/Heading/HeadingPageTitle"

const BoaterPayNow = () => {
  const { register } = useFormContext()
  const { canUpdateSettings, marinaHasAnyPosFeaturesEnabled } = useContext(
    GeneralSettingsContext
  )

  return (
    <div className="form-group flex flex-col space-y-4">
      <HeadingPageTitle>Pay Now</HeadingPageTitle>
      <p>
        Choose whether to enable boaters to make one-time payments on their
        invoices through their Dockwa account. This option provides an
        additional way to pay without affecting existing auto-pay settings.
      </p>
      <Form.Checkbox
        {...register("boater_pay_now_reservations_enabled")}
        label="Enable for reservation invoices"
        disabled={!canUpdateSettings}
      />
      <Form.Checkbox
        {...register("boater_pay_now_contracts_enabled")}
        label="Enable for contract invoices"
        disabled={!canUpdateSettings}
      />
      {marinaHasAnyPosFeaturesEnabled && (
        <Form.Checkbox
          {...register("boater_pay_now_point_of_sale_sales_enabled")}
          label="Enable for point of sale invoices"
          disabled={!canUpdateSettings}
        />
      )}
    </div>
  )
}

export default BoaterPayNow
